var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateMemorableExperiences(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 60 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-8);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 30,
    y1: 0.24,
    x2: 30,
    y2: 56.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 41.7,
    y1: 0.24,
    x2: 41.7,
    y2: 56.35,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 9.44,
    y1: 0.24,
    x2: 9.44,
    y2: 56.35,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 49.89,
    y1: 0.24,
    x2: 49.89,
    y2: 56.35,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 29.89,
    y1: 0.24,
    x2: 29.89,
    y2: 56.35,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 42.33,
    y1: 0.24,
    x2: 42.33,
    y2: 56.35,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 18.17,
    y1: 0.24,
    x2: 18.17,
    y2: 56.35,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 30.41,
    x2: 30.41,
    y2: 56.35,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m17.01,60c-.32-.22-.53-.51-.56-.91-.3-4.52.97-8.31,6.03-10.14,1.06-.38,2.1-.84,3.14-1.26.22-.09.56-.11.49-.47-.1-.52.31-1.14-.3-1.56-.03-.02-.07-.03-.1-.06-1.1-1.17-2.48-1.45-4.05-1.66-4.51-.62-7.18-5.42-5.55-9.67.25-.65.54-1.29.82-1.93.74-1.69,1.38-3.4,1.83-5.21,2.14-8.6,13-11.61,19.33-5.43.38.37.65.75.4,1.29-.18.4-.53.55-.96.5-.3-.03-.49-.23-.68-.42-2.9-2.69-6.29-3.5-10.01-2.24-3.75,1.27-5.86,4.04-6.57,7.95-.39,2.12-1.57,3.97-2.36,5.96-1.06,2.68,0,5.6,2.55,6.93.68.35,1.4.58,2.25.52-1.11-2.95-.57-5.99-.66-8.98-.07-2.21.58-4.23,1.95-5.99.57-.73,1.47-.92,2.16-.32,1.93,1.68,4.22,2.06,6.66,2.05,1.13,0,2.26.02,3.39.09.99.07,1.66.66,1.68,1.63.05,3.29.26,6.59-.15,9.88-.07.53-.28,1.04-.44,1.61.6.14,1.15-.04,1.68-.24,2.88-1.1,4.24-4.27,3.1-7.16-.75-1.9-1.79-3.69-2.3-5.68-.25-.98-.42-1.98-.79-2.92-.22-.55,0-.97.52-1.18.52-.22.92,0,1.16.49.17.35.35.71.41,1.09.44,2.67,1.7,5.04,2.71,7.5,1.71,4.18-.63,8.76-5,9.86-.28.07-.6.22-.85.15-1.86-.47-2.8,1.08-4.11,1.82-.44.25-.22,1.59.25,1.78,1.39.56,2.78,1.12,4.17,1.67.63.25,1.01.69.71,1.36-.29.64-.84.61-1.44.36-1.34-.57-2.7-1.09-4.05-1.63-1.55,3.36-5.8,3.12-7.18-.03-1.91.92-4.08,1.29-5.76,2.71-1.5,1.27-2.22,2.93-2.23,4.89,0,.57-.03,1.13,0,1.7.03.53-.11.95-.5,1.31h-.82Zm8.35-31.47c-.72.96-1.17,1.93-1.29,3.01-.29,2.52-.11,5.06-.11,7.6,0,2.98,2.54,5.66,5.47,5.85,3.24.21,6.15-1.89,6.52-4.93.37-3,.1-6.03.12-9.05,0-.03-.04-.06-.07-.12-3.62-.28-7.48.45-10.63-2.35Zm2.74,18.13c-.36,1.38-.07,2.53.76,3.05.74.46,1.48.42,2.18-.09.74-.54,1-1.84.61-2.95-1.18.31-2.37.19-3.55-.02Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m41.96,60c-.34-.32-.52-.69-.5-1.18.1-2,0-3.96-1.23-5.7-.31-.44-.11-.92.36-1.2.51-.31.94-.11,1.26.34,1.03,1.47,1.47,3.11,1.48,4.89,0,.56,0,1.13,0,1.69,0,.48-.14.87-.55,1.15h-.82Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m8.5,27.36v-4.17c-1.84-.61-1.68-1.73-1.53-3.54.1-1.18.97-1.58,2.84-1.54,1.27.03,2,.57,2.16,1.61.31,1.97-.14,2.96-1.59,3.45v4.26c1.03-2.23,2.57-4.04,3.69-6.1,1.01-1.86.69-4.21-.71-5.78-1.5-1.69-3.77-2.23-5.92-1.42-1.96.74-3.19,2.58-3.19,4.8,0,.33.06.67-.14.97-.26.4-.64.52-1.07.39-.6-.18-.65-.72-.67-1.24-.1-3.18,2-6.02,5.06-6.85,2.94-.8,5.95.22,7.7,2.61,1.77,2.42,1.83,5.51.16,8.11-.68,1.07-1.31,2.18-2.07,3.19-.78,1.04-.97,2.21-1,3.44-.04,1.58-1.14,2.64-2.81,2.63-1.63,0-2.72-1.06-2.76-2.61-.03-1.25-.22-2.44-1.03-3.49-.64-.83-1.16-1.76-1.71-2.65-.29-.47-.2-.93.24-1.23.44-.31.94-.27,1.25.18.96,1.42,1.87,2.88,2.78,4.33.12.19.14.45.21.68.03,0,.06-.01.09-.02Zm.33-7.37c-.03.48-.11.9.05,1.29h1.18c.03-.46.1-.88-.05-1.29h-1.17Zm-.34,9.38c.03.63.29.97.92.98.64,0,.97-.29.97-.98h-1.89Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m49.94,11.94c.56,0,.96.28,1.22.77.27.52.61,1.02.77,1.57.42,1.49,1.43,2.02,2.87,2.02.52,0,1.04.15,1.56.22.58.08.98.39,1.17.93.21.57.07,1.08-.35,1.5-.73.73-1.47,1.46-2.23,2.16-.3.28-.37.56-.3.93.19.99.37,1.99.54,2.99.1.59-.08,1.09-.56,1.45-.46.35-.97.38-1.49.13-.42-.21-.88-.37-1.24-.66-1.35-1.07-2.67-1.06-4.02,0-.35.27-.79.42-1.18.63-.53.29-1.05.27-1.54-.08-.47-.34-.64-.81-.55-1.39.17-1.08.33-2.15.54-3.22.06-.3-.03-.47-.22-.66-.74-.72-1.47-1.45-2.22-2.17-.45-.43-.67-.92-.48-1.53.19-.61.64-.93,1.29-1.02,1.02-.13,2.04-.31,3.06-.44.32-.04.48-.18.61-.45.46-.95.93-1.89,1.39-2.83.28-.56.71-.87,1.35-.84Zm-3.35,12.59c.87-.45,1.66-.83,2.41-1.26.63-.36,1.19-.34,1.81,0,.75.43,1.53.8,2.4,1.26-.13-.73-.19-1.35-.35-1.94-.31-1.16-.15-2.12.88-2.9.53-.4.96-.94,1.48-1.47-.62-.09-1.17-.22-1.73-.24-1.33-.05-2.31-.52-2.75-1.89-.19-.59-.54-1.12-.97-2-.62,3.06-2.33,4.35-5.32,3.97.83.86,1.46,1.51,2.1,2.16.43.43.62.9.49,1.53-.18.89-.3,1.79-.46,2.78Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m29.85,15.65c-4.37-.03-7.86-3.57-7.82-7.94C22.07,3.35,25.64-.03,30.18,0c4.1.02,7.61,3.69,7.56,7.9-.04,4.29-3.6,7.78-7.9,7.75Zm6.01-7.82c0-3.31-2.67-6.01-5.96-6.02-3.28,0-5.97,2.69-5.97,6,0,3.32,2.66,6.01,5.96,6.01,3.3,0,5.97-2.68,5.98-5.99Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m44.11,11.71c.21-.61.54-1.08,1.23-.9.68.18.73.78.71,1.37,0,.08,0,.16,0,.23,0,1.69-.9,2.54-2.62,2.49-.36-.01-.62-.19-.8-.5-.27-.48-.02-.85.28-1.23-1.13-.71-2.31-1.26-3.52-1.75-.61-.25-.98-.64-.71-1.3.27-.67.83-.65,1.43-.41,1.38.55,2.69,1.23,4,1.99Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m18.02,10.4c-.24-.46-.28-.91.13-1.28.4-.36.83-.22,1.27-.08q2.07.69,1.5,2.82c-.03.11-.06.23-.08.34-.13.57-.34,1.06-1.03,1.07-.51,0-.78-.34-.98-1.19-.75.41-1.48.8-2.2,1.22-.54.31-1.03.3-1.37-.24-.36-.58-.1-1.04.45-1.36.74-.42,1.49-.84,2.31-1.3Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m28.92,8.91c1.18-1.19,2.25-2.27,3.31-3.36.46-.47.96-.66,1.47-.17.53.51.3,1.02-.15,1.47-1.26,1.25-2.51,2.5-3.76,3.76-.57.57-1.1.58-1.66,0-.31-.32-.64-.63-.95-.95-.43-.44-.53-.93-.07-1.39.46-.46.95-.35,1.38.09.13.14.24.31.42.55Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateMemorableExperiences);
export default __webpack_public_path__ + "static/media/Create Memorable Experiences.c02affd2dd15beea8b2025aca4d9df3f.svg";
export { ForwardRef as ReactComponent };